import { Grid } from '@mui/material';
import { Spacer } from '../../../components';
import { HelpTitle, HelpBody } from '../../../components/HelpText';
import { ProgressCalculator } from './ReportProgressTracker';
import { findPricebookReportsByType } from '../../../data/report/helpers/pricebookReportUtils';
import { ProductTypeEnum } from '../../../models/PricebookData';
import { sumPropertyAcrossArrayItems } from '../../../helpers/utilityFunctions';

export const progressTracker3NU: ProgressCalculator = summedReport => {
  const reports3nu = findPricebookReportsByType(summedReport, ProductTypeEnum.Nickels);

  return {
    title: '3NickelsU progress',
    totalUsers: summedReport?.totalNickelsU ?? 0,
    notStarted: sumPropertyAcrossArrayItems(reports3nu, 'notStarted3nuCount'),
    inProgress: [
      {
        label: 'Less than 25% complete',
        value: sumPropertyAcrossArrayItems(reports3nu, 'zeroToTwentyFour3nuCount'),
      },
      {
        label: '25-75% complete',
        value: sumPropertyAcrossArrayItems(reports3nu, 'twentyFiveToSeventyFive3nuCount'),
      },
      {
        label: '76-99% complete',
        value: sumPropertyAcrossArrayItems(reports3nu, 'seventySixToNinetyNine3nuCount'),
      },
    ],
    completed: sumPropertyAcrossArrayItems(reports3nu, 'nuCompletedCount'),
    avgProgress: sumPropertyAcrossArrayItems(reports3nu, 'average3nuProgress'),
    helpText: '3NickelsU-eligible users',
    helpContent: <HelpText3nu />,
  };
};

const HelpText3nu = () => {
  return (
    <Grid>
      <HelpTitle>3NickelsU-eligible users</HelpTitle>
      <Spacer height='xxs' />
      <HelpBody>
        Count of users connected to this organization who have access to 3NickelsU content.
      </HelpBody>
    </Grid>
  );
};

export const AvgProgress3nuHelp = () => {
  return (
    <Grid>
      <HelpTitle>Average progress</HelpTitle>
      <Spacer height='xxs' />
      <HelpBody>
        The average progress through 3NickelsU content for all users that have started at least one
        video.
      </HelpBody>
    </Grid>
  );
};
